import { vars } from '@repo/config';
import type { IMergeUserDataRequest } from './merge-user-data-request';
import type { IMergeUserDataResponse } from './merge-user-data-response';
import { mergeUserDataResponseSchema } from './merge-user-data-response';

export async function mergeUserDataApi(
  body: IMergeUserDataRequest,
  serviceApiKey: string,
): Promise<IMergeUserDataResponse> {
  const url = new URL('/internal/users/v1/merge', vars.url.apiUrl);
  const response = await fetch(url.toString(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-service-api-key': serviceApiKey,
    },
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    throw new Error(`Merge user data failed: ${response.status}`);
  }
  const json = await response.json();
  return mergeUserDataResponseSchema.parse(json);
}
